import { BatteryCharging, Droplets, Signal, HeartHandshake } from "lucide-react";

const ITEMS = [
  { icon: BatteryCharging, text: "Batería de 3 días" },
  { icon: Droplets, text: "Resistente al agua" },
  { icon: Signal, text: "Red 4G incluida" },
  { icon: HeartHandshake, text: "Sin redes sociales" },
];

export default function TrustBar() {
  return (
    <section className="bg-[#12263A]">
      <div className="max-w-6xl mx-auto px-5 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {ITEMS.map(({ icon: Icon, text }) => (
          <div key={text} className="flex items-center gap-3" data-testid="trust-item">
            <Icon size={26} strokeWidth={2} className="text-[#F3F2F2] shrink-0" />
            <span className="text-[15px] font-bold text-[#F3F2F2]">{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
